import ChatWeb from "./ChatWeb.component";


export default ChatWeb;
